<mat-dialog-content>
    <div *ngIf="isLoading" class="overlay"></div>
    <div *ngIf="isLoading" class="loader"></div>
    <mat-tab-group class="mat-tab-group">
        <mat-tab label="General Data">
            <mat-card>
                <mat-card-content>
                    <h1 class="menu-sub-item-header mat-icon-container">{{isUpdate ? 'Maintain' : 'Create'}} Supplier</h1>
                    <p>
                    <form [formGroup]="supplierForm">

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Name: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="title" matInput formControlName="title" required />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Address: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="supplierAddress" matInput formControlName="supplierAddress" required />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Description: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="description" matInput formControlName="description" required />
                                </div>
                            </div>
                        </div>
                     
                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Supplier Website: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="supplierWebsite" matInput formControlName="supplierWebsite" required />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Supplier Email: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="supplierEmail" matInput formControlName="supplierEmail" required />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Supplier Phone: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="supplierPhone" matInput formControlName="supplierPhone" required />
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <div class="col1">
                                <div class="mat-form-small-container">
                                    <label>Supplier Contact: </label>
                                </div>
                            </div>
                            <div class="col2">
                                <div class="mat-form-small-container">
                                    <input name="supplierContact" matInput formControlName="supplierContact" required />
                                </div>
                            </div>
                        </div>

                    </form>
                </mat-card-content>
                <mat-card-actions class="mat-form-button-container">
                    <div class="flex flex-align-items-center">
                        <div class="mr-auto">
                        </div>
                        <button style="float: none;" type="button" mat-raised-button (click)="dialogRef.close()"
                            color="warn">Cancel</button>
                        <button style="float: none;" type="button" mat-raised-button (click)="isUpdate ? updateSupplier() : addSupplier()" 
                        color="warn" [disabled]="!supplierForm.valid">{{isUpdate ? 'Save' : 'Add'}}</button>
                    </div>
                </mat-card-actions>
            </mat-card>
        </mat-tab>

    </mat-tab-group>
</mat-dialog-content>
